// node modules
import React, { PureComponent } from 'react';

// app modules: components
import SearchResultsMatrix from 'components/SearchResultsMatrix';
import ContentTile from 'components/ContentTile';

// app modules: props
import SearchResultsMatrixProps from 'components/SearchResultsMatrix/SearchResultsMatrixProps';

// app modules: constants
import { CONTENT_TYPES } from 'constants/index';

class ContentsMatrix extends PureComponent {
  static propTypes = SearchResultsMatrixProps;

  static defaultProps = {
    ItemComponent: ContentTile,
    itemKey: 'id',
    itemType: CONTENT_TYPES.CONTENT,
    itemWidth: 230,
  };

  render() {
    return <SearchResultsMatrix {...this.props} />;
  }
}

export default ContentsMatrix;
